import { Badge } from "@mantine/core";

interface StatusBadgeProps {
  color: string;
  status: string;
}

export default function StatusBadge({ color, status }: StatusBadgeProps) {
  return (
    <Badge
      px="xs"
      h="20px"
      size="xs"
      fw="bold"
      radius="xs"
      color="gray.7"
      variant="outline"
      style={{
        borderRadius: 2,
      }}
      bd={`1px solid var(--mantine-color-${color}-6)`}
      leftSection={
        <div
          style={{
            height: 6,
            width: 6,
            borderRadius: "50%",
            backgroundColor: `var(--mantine-color-${color}-6)`,
          }}
        />
      }
    >
      {status}
    </Badge>
  );
}
